import cn from 'classnames'
import React from 'react'
import CollectionHeader from '../assetpreview/CollectionHeader'
import Link from '../common/util/input/Link'
import { VolumeDisplay } from './VolumeDisplay'

function CollectionPreviewForSlider(props) {
    const collectionItem = props['collection']
    const isBeingDragged = props['isBeingDragged']

    const {
        name,
        image,
        collection,
        thumbnail,
        verified,
        blacklisted,
        customHref,
    } = collectionItem

    return (
        <Link
            className={cn(
                'cursor-pointer w-56 h-full rounded-2xl ',
                'dark:!bg-paper bg-zinc-200 transition-colors ',
                'backdrop-filter backdrop-blur-sm overflow-hidden',
            )}
            href={customHref ? customHref : '/collection/' + collection}
            inactive={isBeingDragged}
        >
            <div className={'h-full'}>
                <div
                    className={
                        'flex w-56 min-w-56 h-56 m-auto cursor-pointer bg-white dark:!bg-page '
                    }
                >
                    <img
                        className={'flex h-auto m-auto'}
                        src={thumbnail ? thumbnail : image}
                        alt={name}
                        height={240}
                        width={240}
                    />
                </div>
                <CollectionHeader
                    displayName={name}
                    author={collection}
                    verified={verified}
                    blacklisted={blacklisted}
                    href={customHref ? customHref : '/collection/' + collection}
                />
                <VolumeDisplay collectionItem={collectionItem} />
            </div>
        </Link>
    )
}

export default CollectionPreviewForSlider
